import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Field, FieldOption, FieldOptionsRequest } from '../../../../../admin-portal/admin/models/safr-type';
import { SafrAdminService } from '../../../../../admin-portal/admin/services/safr-admin.service';
import { SafrManagementService } from '../../../../../admin-portal/admin/services/safr-management.service';

@Component({
  selector: 'wre-edit-field',
  templateUrl: './edit-field.component.html',
  styleUrls: ['./edit-field.component.sass']
})
export class EditFieldComponent {

  private _field: Field;
  private _loading = false;
  private _duplicate = false;
  private _invalid = false;

  @Output() closeModalEvent = new EventEmitter<boolean>(false);
  @Output() errorEvent = new EventEmitter<any>();

  @Input() set field(value: Field) {
    this._field = value;
    this.patchFieldForm();
  }

  form: UntypedFormGroup;
  formField: Field;
  addedValue: FieldOption;
  control: AbstractControl;
  disabledSaveChangesButton: boolean;
   toggleBtnVal: boolean = true;

  get loading() { return this._loading; }

  get fieldname() {
    return this._field ? this._field.name : '';
  }

  get duplicate() {
    const duplicateValue = this._duplicate && this.form.get('newValue').value !== '';
    this._duplicate = duplicateValue;

    return duplicateValue;
  }
  get invalid() {
    const invalidValue = this._invalid && this.form.get('newValue').value?.trim() == '';
    this._invalid = invalidValue;
    return invalidValue;
  }

  constructor(
    private fb: UntypedFormBuilder,
    private _safrAdminService: SafrAdminService,
    private _safrManagementService: SafrManagementService) {
    this.initialiseForm();
  }

  async saveChanges() {
    this.disabledSaveChangesButton = true;
    this._loading = true;
    const fieldOptionsRequest = new FieldOptionsRequest(this.form.get('options').value);
    await this._safrAdminService.updateField(this._field.id, fieldOptionsRequest).subscribe(response => {
      this._safrManagementService.loadFields();
      this.closeModalEvent.emit(true);
      this._loading = false;
      this.disabledSaveChangesButton = false;
    }, error => {
      this.errorEvent.emit(error);
      this._loading = false;
      this.disabledSaveChangesButton = false;
    });
  }

  private initialiseForm() {
    this.form = this.fb.group({
      id: '',
      options: this.fb.control([]),
      newValue: ['',
      [Validators.pattern('[a-zA-Z0-9 _-]*'),
      Validators.pattern('.*[^ ].*')]],
      isActive: true
    });
  }

  private patchFieldForm() {
    this.form.patchValue(this._field);

    (this.form.get('options') as UntypedFormControl)
      .setValue(this._field.options.map(f => new FieldOption(f.name, f.email, f.id, f.active)));
  }

  add() {
    this.control = this.form.get('options');
    this.addedValue = new FieldOption(this.form.get('newValue').value?.trim(), null, null, this.form.get('isActive').value);
    if (this.form.get('newValue').value && this.form.get('newValue').value?.trim() !== '')
    {
      this._invalid = false;
      if (!this.control.value.map(f => f.name.trim().toLowerCase()).includes(this.addedValue.name.toLowerCase())) {
        this._duplicate = false;
        const currentValue = this.control.value !== undefined ? this.control.value : [];
        currentValue.splice(0, 0, this.addedValue)
        this.control.setValue(currentValue);

        this.form.get('newValue').reset();
      } else {
        this._duplicate = true;
        this.form.get('newValue').setErrors({ 'customError': true });
      }
    }
    else {
          this._invalid = true;
          this.form.get('newValue').setErrors({ 'customError': true });
    }

    this.control.markAsDirty();
  }

  isDisabled() {
    return this.disabledSaveChangesButton || (this._field !== undefined
      ? !this.isFieldChanged(this._field.options, this.form.get('options').value) || this.form.invalid
      : true);
  }

  private isFieldChanged(fieldsToUpdate: FieldOption[], newFields: FieldOption[]): boolean {
    if (fieldsToUpdate.length !== newFields.length) {
      return true;
    }

    fieldsToUpdate = fieldsToUpdate.sort((a, b) => a.name.localeCompare(b.name));
    newFields = newFields.sort((a, b) => a.name.localeCompare(b.name));

    for (var index = 0; index < newFields.length; index++) {
      if 
        (
          !(fieldsToUpdate[index].id === newFields[index].id &&
          fieldsToUpdate[index].name?.trim() === newFields[index].name?.trim() &&
          fieldsToUpdate[index].email?.trim() === newFields[index].email?.trim() &&
          fieldsToUpdate[index].active === newFields[index].active)
        ) {
        return true;
      }
    }

    return false;
  }
  getToggleValue(){
    this.toggleBtnVal = !this.toggleBtnVal;
  }
  onKeypressEvent(event: any){
    this._invalid = false;
    this._duplicate=false;
  }
}
